import type { JSX, ReactNode } from 'react';
import clsx from 'clsx';

/**
 * EntityFilterBar provides a consistent horizontal filter layout with optional action slot.
 * It mirrors the existing dashboard styling while allowing shared reuse across entity views.
 */
export function EntityFilterBar({
  children,
  className,
  containerClassName,
  actions,
}: {
  children: ReactNode;
  className?: string;
  containerClassName?: string;
  actions?: ReactNode;
}): JSX.Element {
  return (
    <section
      className={clsx(
        'flex flex-col gap-md border-b border-surface-subtle bg-surface-light/60 pb-4',
        'md:flex-row md:items-end md:justify-between md:gap-lg',
        className,
      )}
    >
      <div
        className={clsx(
          'flex flex-1 flex-col gap-sm md:flex-row md:flex-wrap md:items-end md:gap-md',
          containerClassName,
        )}
      >
        {children}
      </div>
      {actions != null ? <div className="mt-sm md:mt-0">{actions}</div> : null}
    </section>
  );
}
